import { ListItem } from '@mui/material';
import { List, Paper, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Filter } from './types';
import { Box } from '@mui/material';

export const FILTERS: Filter[] = [
  {
    id: 'product_group',
    label: 'Product Group',
    options: [
      'crude',
      'gasoline',
      'naptha',
      'distillate',
      'jet_fuel',
      'fuel_oil',
      'petrochemical',
      'freight',
      'methane',
      'ethane',
      'propane',
      'butane',
      'pentane',
      'ngl',
      'refinery_margin',
      'agriculture',
    ],
  },
  {
    id: 'product_type',
    label: 'Product Type',
    options: ['spot', 'future', 'option', 'swap', 'weekly_swap', 'daily_swap', 'future_swap', 'composite', 'calendar', 'index'],
  },
  {
    id: 'calendar_type',
    label: 'Calendar Type',
    options: ['flat', 'spread', 'quarter', 'butterfly', 'condor', 'year'],
  },
  {
    id: 'tenor_frequency',
    label: 'Tenor Frequency',
    options: ['daily', 'weekly', 'monthly', 'quarterly', 'yearly'],
  },
];

export const FilterSection = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  border: `1px solid ${theme.palette.border}`,
  borderRadius: '8px',
  padding: '16px',
  marginRight: '16px',
}));

export const FilterTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(1),
  fontWeight: 'bold',
}));

export const FilterOptions = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  maxHeight: '200px',
  overflowY: 'auto',
}));

export const ResultsContainer = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  height: '100%',
  overflowY: 'auto',
}));

export const ProductList = styled(List)(() => ({
  width: '100%',
}));

export const ProductListItem = styled(ListItem)(({ theme }) => ({
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
}));
